import { IN_PROGRESS_SCREEN } from 'config/config';
import queryString from 'query-string';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';
import { ILoadingState } from 'types/ILoadingState';
import { IPayment } from 'types/Payment';

import { RecoveryPaymentButton } from '../recoveryPaymentButton/RecoveryPaymentButton';
import RecoveryPaymentButtonStyleType from '../recoveryPaymentButton/RecoveryPaymentButton.types';
import Spinner from '../spinner/Spinner';
import {
  StatusScreenContainer,
  StatusScreenIcon,
  StatusScreenMessage,
  StatusScreenRetryMessage,
  StatusScreenStatus,
  StatusScreenStatusText,
  StatusScreenWrapper,
} from '../statusScreen/StatusScreen.styles';

import InProgressStatusScreenButton from './InProgressScreen.styles';

interface IProps extends RouteComponentProps {
  paymentId: string;
  paymentDetails: Partial<IPayment>;
}

const { status, statusText, icon, description, buttonText, retryMessage } = IN_PROGRESS_SCREEN;

class InProgressScreen extends PureComponent<IProps, ILoadingState> {
  innerRef = React.createRef<HTMLDivElement>();

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  setLoading = () => {
    this.setState({ isLoading: true });
  };

  handleError = (error: Error) => {
    this.setState(() => {
      throw error;
    });
  };

  redirectToPayments = () => {
    const { token } = queryString.parse(window.location.search);
    const { paymentId } = this.props;
    if (!token || !paymentId) {
      throw new Error('No token or payment id');
    }
    const { history } = this.props;
    return history.push(`/${paymentId}?token=${token}`);
  };

  isPaymentContinue = (paymentDetails: Partial<IPayment>) => paymentDetails.redirectUrl;

  render() {
    const { paymentDetails, paymentId } = this.props;
    const { isLoading } = this.state;
    const containerHeight = this.innerRef.current ? this.innerRef.current.offsetHeight : 0;
    return (
      <StatusScreenContainer
        isLoading={isLoading}
        height={containerHeight}
        ref={this.innerRef}
        className="in-progress-status__container"
      >
        {isLoading ? (
          <Spinner isLoading={isLoading} />
        ) : (
          <StatusScreenWrapper>
            <StatusScreenStatus className="in-progress-status__status">
              <FormattedMessage id={status} />
            </StatusScreenStatus>
            <StatusScreenStatusText className="in-progress-status__statusText">
              <FormattedMessage id={statusText} />
            </StatusScreenStatusText>
            <StatusScreenIcon className="in-progress-status__icon">
              <img src={icon} alt="icon" />
            </StatusScreenIcon>
            <StatusScreenMessage className="in-progress-status__message">
              <FormattedMessage id={description} />
            </StatusScreenMessage>
            {this.isPaymentContinue(paymentDetails) ? (
              <>
                <StatusScreenRetryMessage>
                  <FormattedMessage id={retryMessage} />
                </StatusScreenRetryMessage>
                <InProgressStatusScreenButton className="in-progress-status-screen__button ">
                  <button
                    className="in-progress-screen__continue-payment-button"
                    type="button"
                    onClick={this.redirectToPayments}
                  >
                    <FormattedMessage id={buttonText} />
                  </button>
                </InProgressStatusScreenButton>
              </>
            ) : (
              <>
                {paymentDetails.pendingRecoveryEnabled ? (
                  <>
                    <StatusScreenRetryMessage>
                      <FormattedMessage id={retryMessage} />
                    </StatusScreenRetryMessage>
                    <InProgressStatusScreenButton className="in-progress-status-screen__button">
                      <RecoveryPaymentButton
                        className="in-progress-screen__recovery-payment-button"
                        paymentId={paymentId}
                        isRecoveryEnabled={paymentDetails.pendingRecoveryEnabled}
                        message={buttonText}
                        onClick={this.setLoading}
                        onError={this.handleError}
                        type={RecoveryPaymentButtonStyleType.RETRY}
                      />
                    </InProgressStatusScreenButton>
                  </>
                ) : (
                  <></>
                )}
              </>
            )}
          </StatusScreenWrapper>
        )}
      </StatusScreenContainer>
    );
  }
}

export default withRouter(InProgressScreen);
